import { combineReducers } from "redux";
import * as actionTypes from "../actionTypes";
import initialState from "../../../../../reducers/initialState";
import { OFFER_CREATED } from "features/offer/edit/assets/asset/eventTypes";

const listReducer = (state = initialState.responsibleChangeOffers.list, action) => {
  switch (action.type) {
    case actionTypes.LOAD_RESPONSIBLE_CHANGE_OFFERS_STARTED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: true, loaded: false };
      return result;
    }

    case actionTypes.LOAD_RESPONSIBLE_CHANGE_OFFERS_SUCCEEDED: {
      const { key, page, totalCount, totalPages } = action;
      let result = { ...state };
      result[key] = { ...state[key], totalCount, totalPages };
      result[key][page] = { ...result[key][page], ids: [...action.result], loading: false, loaded: true };
      return result;
    }

    case actionTypes.LOAD_RESPONSIBLE_CHANGE_OFFERS_FAILED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: false, loaded: false };
      return result;
    }

    case OFFER_CREATED: {
      return initialState.responsibleChangeOffers.list;
    }

    default:
      return state;
  }
};

const reducer = combineReducers({
  list: listReducer
});

export default reducer;
